<template>
  <div>
    <button v-if="userType == 'employer'" class="mylisting-button dark-button" @click="showAddUserModal()">Add Client</button>
    <button v-if="userType == 'candidate'" class="mylisting-button dark-button" @click="showAddUserModal()">Add Candidate</button>

    <modal name="add-user-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h2>Add New User</h2>
        <hr>
        <label class="top-label">Email*</label>
        <input type="text" class="form-control" v-model="email">
        <label class="">Phone Number</label>
        <input type="text" class="form-control" v-model="phone">
        <label class="">First Name</label>
        <input type="text" class="form-control" v-model="firstName">
        <label class="">Last Name</label>
        <input type="text" class="form-control" v-model="lastName">
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('add-user-modal')">Cancel</button>
        <button class="mylisting-button dark-button" @click="addUser()" v-if="email" style="float: right;">Add</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['userType'],
  data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      phone: '',
    }
  },
  methods: {
    showAddUserModal() {
      this.email = ''
      this.firstName = ''
      this.lastName = ''
      this.phone = ''
      this.$modal.show('add-user-modal')
    },
    addUser() {
      axios.post('/create-user/', {
        email: this.email,
        password: this.email,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          let is_employer = false
          let is_candidate = false
          if (this.userType == 'employer') {
            is_employer = true
          }
          else if (this.userType == 'candidate') {
            is_candidate = true
          }
          axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
            {
              agency: this.$store.getters.agencyID,
              agency_owner: this.$store.getters.agencyName,
              // user_type: authData.user_type,
              // is_employer: this.is_employer,
              is_candidate: is_candidate,
              is_employer: is_employer,
              // status: 'New',
              status: 'Pre Application',
              // numberArray: [0, 0, 0, 0],
              first_name: this.firstName,
              last_name: this.lastName,
              phone: this.phone,
            }
          )
            .then(res => {
              console.log(res)

              // this.getAgents()
              // this.$emit('userAdded')
              if (this.userType == 'employer') {
                this.$emit('employerAdded')
              }
              else if (this.userType == 'candidate') {
                this.$emit('candidateAdded')
              }
              this.$modal.hide('add-user-modal')
            })
            .catch(error => console.log(error))
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/agents/functions/AddUser.vue